import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { getBoardTemplates } from '../requests';
import type { GetBoardTemplatesRequestType } from '../types';

export const useGetBoardTemplates = (
  {
    queryParams: {
      base,
      from,
      id,
      name,
      page,
      perPage,
      public: publicParam,
      sortBy,
      sortDir,
      to,
    },
  }: Omit<GetBoardTemplatesRequestType, 'pathParams'>,
  options?: {
    enabled?: boolean;
    keepPreviousData?: boolean;
  },
) => {
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId();

  return useQuery({
    queryKey: [
      API_QUERY_KEYS.boardTemplates,
      {
        organisationId,
        boardId,
        base,
        from,
        id,
        name,
        page,
        perPage,
        public: publicParam,
        sortBy,
        sortDir,
        to,
      },
    ],
    queryFn: () =>
      getBoardTemplates({
        pathParams: { organisationId, boardId: boardId! },
        queryParams: {
          base,
          from,
          id,
          name,
          page,
          perPage,
          public: publicParam,
          sortBy,
          sortDir,
          to,
        },
      }),
    ...options,
  });
};
